module.exports = __webpack_public_path__ + "img/button_grid.d3bb9968.png";